import React, { useContext } from "react";
import { TimelineGridContext, DATE_COLUMN_WIDTH } from "../../components/timelinePlanner/timelinePlannerGrid";

interface CellSelectionConfig {
    targetId: string;
    selectedCell?: { day: string; targetId: string } | null;
    onCellSelect: (cell: { day: string; targetId: string }, event: React.MouseEvent) => void;
}

export const useCellSelection = (config?: CellSelectionConfig) => {
    const context = useContext(TimelineGridContext);

    const handleGridClick = (e: React.MouseEvent) => {
        if (!config) return;

        // Only handle clicks on empty areas (not on shift cells)
        const target = e.target as HTMLElement;
        const isShiftCell = target.closest(".timeline-grid-cell") &&
                        !target.closest(".timeline-grid-background-cell");

        if (!isShiftCell) {
            const gridElement = e.currentTarget as HTMLElement;
            const rect = gridElement.getBoundingClientRect();
            const clickX = e.clientX - rect.left;

            const columnIndex = Math.floor(clickX / DATE_COLUMN_WIDTH);
            const dates = context?.getGridDates() || [];

            if (columnIndex >= 0 && columnIndex < dates.length) {
                const clickedDate = dates[columnIndex];
                config.onCellSelect(
                    { day: clickedDate, targetId: config.targetId },
                    e
                );
            }
        }
    };

    const generateBackgroundCells = () => {
        if (!config || !context) return [];

        return context.getGridDates().map((date, index) => {
            const isSelected = config.selectedCell?.day === date &&
                              config.selectedCell?.targetId === config.targetId;

            return (
                <div
                    key={`bg-${date}`}
                    style={{
                        gridColumn: `${index + 1}/${index + 2}`,
                        gridRow: 1,
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        zIndex: -1,
                        backgroundColor: isSelected ? "rgba(33, 150, 243, 0.12)" : "transparent",
                    }}
                    className="timeline-grid-background-cell"
                />
            );
        });
    };

    return {
        handleGridClick: config ? handleGridClick : undefined,
        backgroundCells: generateBackgroundCells()
    };
};